import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CasinoGamesSelect } from 'src/domains/layouts/shared/formComponents/Select/casinoSelectGames/SelectCasinoGames';
import {
    CasinoBannersDataState,
    RedirectTypeEnum,
} from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

interface PropsType {
    casinoBannersData: CasinoBannersDataState;
}

export const RedirectOptions = observer(({ casinoBannersData }: PropsType): React.ReactElement | null => {
    const { appCasinoState } = useAppStateContext();
    const { casinoGamesList, liveCasinoGamesList } = appCasinoState.gameStore;
    const { redirectUrl, redirectGame, redirectType, redirectionError, collection } = casinoBannersData;
    const selectOptions = collection === 'casino' ? casinoGamesList : liveCasinoGamesList;
    return (
        <>
            {redirectType.value === RedirectTypeEnum.REDIRECT_URL && (
                <Input
                    inputType='url'
                    label='Direct link'
                    formInputState={redirectUrl}
                    dataTest='banner-direct-link'
                />
            )}
            {redirectType.value === RedirectTypeEnum.REDIRECT_GAME && (
                <CasinoGamesSelect
                    defaultText='Select game'
                    selectOptions={selectOptions}
                    stateValue={redirectGame}
                    dataTest='banner-game-select'
                />
            )}
            {redirectionError !== null && <ErrorMessageBar>{redirectionError}</ErrorMessageBar>}
        </>
    );
});
